// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { func, string } from 'prop-types';

const StyledWelcome = styled.div`
  display: flex;
  gap: 3px;
  flex-direction: column;
  font-size: 12px;
  color: #3a3a3a;

  .resellerName {
    font-weight: 700;
  }

  @media screen and (max-width: ${ props => props.theme.device.tablet }) {
    display: none;
  }
`;

const WelcomeSection = ({ resellerName, t }) => (
  <StyledWelcome className="sideBarLeft">
    <span>{t('common.welcome')},</span>
    <span className="resellerName">{resellerName}</span>
  </StyledWelcome>
);

WelcomeSection.propTypes = {
  resellerName: string.isRequired,
  t: func.isRequired,
};

export default WelcomeSection;
